import { FaRocket } from "@onemind-services-llc/react-icons-ng/fa";
import { GiTeamIdea } from "@onemind-services-llc/react-icons-ng/gi";
import {
  RiPassValidLine,
  RiUserSettingsFill,
} from "@onemind-services-llc/react-icons-ng/ri";

export const MIGRATION_CONSTANTS = {
  TITLE: "OneMind’s K8s Migration Workflow",
  ITEMS: [
    {
      icon: FaRocket,
      title: "Cluster Discovery & Audit",
      text: "We assess your current environment — whether it’s EKS, AKS, GKE, self-hosted, or on-prem — and map resources, namespaces, ingress, volumes, and dependencies.",
    },
    {
      icon: GiTeamIdea,
      title: "Platform Blueprinting",
      text: "We build a custom PaaS architecture on OneMind, matching workload specs, storage class requirements, secrets, and service meshes (if present).",
    },
    {
      icon: RiUserSettingsFill,
      title: "CI/CD & Pipeline Realignment",
      text: "Jenkins, GitHub Actions, ArgoCD, or GitLab — your pipeline flows are re-integrated into the new environment with minimal disruption.",
    },
    {
      icon: RiPassValidLine,
      title: "Migration & Validation",
      text: "Deploy workloads to OneMind PaaS using Helm, Kustomize, or raw YAML. We verify ingress, scaling, logs, metrics, and custom controllers' pre-cutover.",
    },
  ],
};
